import {
	Box,
	Text,
	Badge,
	VStack,
	Grid,
	GridItem,
	HStack,
	Link,
} from "@chakra-ui/react";
import dayjs from "newui/utils/dayjs";
import { DashboardRfxItemData } from "../types/DashboardRfxItemData";
import { DashboardProgressBar } from "./DashboardProgressBar";
import { SubmissionDeadline } from "components/RFQ/SubmissionDeadline/SubmissionDeadline";
import { Icon } from "assets/Icon";
import { getProjectUrl, getRfxUrl } from "helpers/linkHelper";
import { RFX_STATUS } from "utils/constants";
import UnreadMessage from "newui/components/UnreadMessage";

export const RfxDashboardItem: React.FC<{
	companyId: number;
	item: DashboardRfxItemData;
	showSupplierGuests?: boolean;
	viewByProject: boolean;
}> = ({ item, companyId, viewByProject = false }) => {
	const responses =
		item.statusCounts.accepted +
		item.statusCounts.responsesInProgress +
		item.statusCounts.submitted;
	const rfxUrl = getRfxUrl(companyId, item.rfxId, item.rfxName);
	const projectUrl = getProjectUrl(companyId, item.projectId, item.projectName);

	return (
		<Box>
			<HStack spacing={1}>
				<Link
					href={rfxUrl}
					target="_blank"
				>
					<HStack>
						<Icon
							icon={"open-in-new-window"}
							className={"p-0"}
							style={{ width: "25px", height: "25px" }}
						/>
						<Text
							className="text-wrap font-bold text-gray-800"
							sx={{
								"@media screen and (min-width: 450px)": {
									fontSize: 16,
								},
								"@media screen and (max-width: 450px)": {
									gridColumn: "span 1",
									fontSize: 14,
								},
							}}
						>
							{item.rfxName}
						</Text>
					</HStack>
				</Link>
				{!viewByProject && (
					<Link
						href={projectUrl}
						target="_blank"
					>
						<Text
							className="text-sm"
							sx={{
								"@media screen and (min-width: 450px)": {
									fontSize: 14,
								},
								"@media screen and (max-width: 450px)": {
									gridColumn: "span 1",
									fontSize: 12,
								},
							}}
						>
							{item.projectName}
						</Text>
					</Link>
				)}
			</HStack>
			<Grid
				className="mb-0 rounded-lg p-0"
				templateRows="auto auto"
				sx={{
					"@media screen and (min-width: 890px)": {
						templateColumns: "minmax(0, 200px) minmax(0, 100px) 1fr",
					},
				}}
				gap={2}
			>
				{/* <GridItem
				gridRow={1}
				colSpan={3}
				sx={{
					"@media screen and (min-width: 450px)": {
						gridColumn: "span 2"
					},
					"@media screen and (max-width: 450px)": {
						gridColumn: "span 1",
						fontSize: 13
					},
				}}
			>
				<Text className="text-wrap font-bold text-gray-800">
					{item.rfxName} {viewType === 2 && `(${item.projectName})`}
				</Text>
			</GridItem> */}
				<GridItem
					gridColumn={{ base: "1", md: "1" }}
					gridRow={{ base: "2", md: "2" }}
					colSpan={1}
					maxW={200}
					sx={{
						"@media screen and (min-width: 450px)": {
							fontSize: 14,
						},
						"@media screen and (max-width: 450px)": {
							gridColumn: "span 1",
							fontSize: 11,
						},
					}}
				>
					{/* Left side: RFx Details */}
					<Box width="200px">
						<VStack
							align="start"
							spacing={2}
						>
							{item.unreadMessages > 0 && (
								<UnreadMessage size="sm" value={item.unreadMessages} />
							)}
							<VStack
								align="start"
								spacing={1}
							>
								<Text className="font-medium text-gray-600">Deadline:</Text>
								<SubmissionDeadline
									submissionStatus={RFX_STATUS.IN_PROGRESS}
									deadlineDateTime={new Date(item.submissionDeadline)}
									deadlineTimeZone=""
								/>
							</VStack>
						</VStack>
					</Box>
				</GridItem>
				<GridItem
					display="flex"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
					colSpan={1}
					sx={{
						"@media screen and (min-width: 450px)": {
							gridColumn: 2,
							gridRow: 2,
						},
						"@media screen and (min-width: 700px)": {
							gridColumn: 2,
							gridRow: 2,
							paddingLeft: "0px",
						},
						"@media screen and (max-width: 450px)": {
							paddingLeft: "0px",
							gridColumn: 1,
							gridRow: 3,
						},
					}}
				>
					<Grid>
						<GridItem
							gridColumn={1}
							className="mx-auto ml-3 mr-3 flex h-16 w-16 items-center justify-center rounded-full bg-blue-600 text-white"
						>
							<Text className="font-bold">
								{responses}/{item.statusCounts.invitationsSent}
							</Text>
						</GridItem>
						<GridItem
							className="text-center"
							paddingRight={{ xl: "3" }}
							paddingTop={{ xl: "3" }}
							gridColumn={{ base: 1, xl: 2 }}
						>
							<Text className="text-sm font-medium text-blue-600">
								Response
							</Text>
							<Text className="text-sm font-medium text-blue-600">Outlook</Text>
						</GridItem>
					</Grid>
				</GridItem>
				<GridItem
					width={{ base: "100%" }}
					className="align-middle"
					display="flex"
					alignItems="center"
					maxW="auto"
					gridRow={{ base: 4, sm: 3, md: 2 }}
					gridColumn={{ base: 1, sm: "1 / span 2", md: 3 }}
					sx={{
						"@media screen and (min-width: 450px)": {
							gridColumn: "1 / span 2",
							gridRow: 3,
						},
						"@media screen and (min-width: 700px)": {
							gridRow: 2,
							gridColumn: "3",
						},
						"@media screen and (max-width: 450px)": {
							gridColumn: 1,
							gridRow: 4,
						},
					}}
				>
					<Box w="100%">
						<DashboardProgressBar item={item} />
					</Box>
				</GridItem>
			</Grid>
		</Box>
	);
};
